import type { IPresetReplayResult } from './types';

export const createEmptyPresetReplayResult = (): IPresetReplayResult => ({
  completedSteps: 0,
  skippedSteps: [],
  errors: [],
  processedData: [],
});
